export const FETCH_ALL_ORGS = 'FETCH_ALL_ORGS';
